"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var polls = {};
function getPoll(id) {
    return polls[id];
}
exports.getPoll = getPoll;
function cancelPoll(id) {
    if (polls[id]) {
        clearTimeout(polls[id]);
        delete polls[id];
    }
}
exports.cancelPoll = cancelPoll;
function poll(id, apiFn, conditionChecker, interval) {
    if (interval === void 0) { interval = 2000; }
    var checkCondition = function (resolve, reject) {
        apiFn()
            .then(function (response) {
            if (conditionChecker(response)) {
                resolve(response);
            }
            // if condition is not met, check condition again after provided interval
            else {
                cancelPoll(id);
                polls[id] = setTimeout(checkCondition, interval, resolve, reject);
            }
        })
            .catch(function () {
            cancelPoll(id);
            polls[id] = setTimeout(checkCondition, interval, resolve, reject);
        });
    };
    return new Promise(checkCondition);
}
exports.poll = poll;
//# sourceMappingURL=poll.js.map